<template>
  <div class="events">
    <p class="h3 events__title">Список событий</p>
    <div class="events__panel">
      <AppMenu
        v-model="activeMenuItem"
        :items="menuItems"
      />
      <BaseButton
        theme="light"
        class="button"
        href="create-event"
      >
        + Добавить событие
      </BaseButton>
    </div>

    <KeepAlive>
      <component
        :is="componentName"
        class="window"
      />
    </KeepAlive>
  </div>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import BaseButton from '@/components/Base/BaseButton'
import AppList from './components/AppList'
import AppMap from './components/AppMap'

export default {
  name: 'eventsPage',
  components: {
    AppMenu,
    BaseButton,
    AppList,
    AppMap
  },
  data () {
    return {
      menuItems: [
        { value: 'list', label: 'Список', component: 'AppList' },
        { value: 'map', label: 'Карты', component: 'AppMap' }
      ],
      activeMenuItem: 'list'
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    }
  },
  watch: {
    activeMenuItem (newValue) {
      this.$router.push({
        path: this.$route.fullPath,
        query: { tab: newValue }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.events {
  color: #C6C6CE;
  display: flex;
  flex-direction: column;

  &__title {
    color: #fff;
  }

  &__panel {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .button {
      padding: 0 20px;
    }
  }

  .window {
    //flex-grow: 1;
    height: 800px;
    margin-top: 20px;
    position: relative;
  }
}
</style>
